module.exports = __webpack_public_path__ + "img/map-1.a2457047.gif";